export const work = [
    {
        id: "studio-floor",
        category: "Studio",
        title: "Inside the studio — BMW X7, Z4 and GLA in progress",
        image: "/assets/work/studio-floor.webp",
        alt: "Real Revautoz studio floor — technicians polishing a BMW X7 and Mercedes GLA with a BMW Z4 behind",
        aspect: "aspect-[4/3]",
        placeholder: false,
    },
    {
        id: "ceramic-application",
        category: "Ceramic",
        title: "Hand-applied ceramic coating",
        image: "/assets/work/ceramic-application.webp",
        alt: "Real Revautoz work — ceramic coating being hand-applied to a black SUV",
        aspect: "aspect-[4/5]",
        placeholder: false,
    },
    {
        id: "ppf-installation",
        category: "PPF",
        title: "Precision PPF installation",
        image: "/assets/work/ppf-installation.webp",
        alt: "Real Revautoz work — paint protection film being squeegeed onto a bonnet",
        aspect: "aspect-[4/5]",
        placeholder: false,
    },
    {
        id: "bodyshop-paint",
        category: "Bodyshop",
        title: "Panel refinishing in the booth",
        image: "/assets/work/bodyshop-paint.webp",
        alt: "Real Revautoz work — spray-painting a masked SUV panel in the bodyshop",
        aspect: "aspect-[4/5]",
        placeholder: false,
    },
    {
        id: "custom-interior-thar",
        category: "Custom",
        title: "Thar Roxx interior retrim",
        image: "/assets/work/custom-interior-thar.webp",
        alt: "Real Revautoz work — custom black leather interior with red stitching being fitted in a Mahindra Thar Roxx",
        aspect: "aspect-[4/5]",
        placeholder: false,
    },
    {
        id: "paint-correction-gloss",
        category: "Paint Correction",
        title: "Machine correction on the studio floor",
        image: "/assets/work/studio-wide-aprons.webp",
        alt: "Real Revautoz work — technician machine-polishing a Hyundai SUV on the studio floor",
        aspect: "aspect-[4/3]",
        placeholder: false,
    },
    {
        id: "detailing-bay",
        category: "Detailing",
        title: "Full-floor detailing in progress",
        image: "/assets/work/studio-floor-2.webp",
        alt: "Real Revautoz work — multiple vehicles being detailed across the studio floor",
        aspect: "aspect-[4/5]",
        placeholder: false,
    },
    {
        id: "restoration-classic",
        category: "Restoration",
        title: "Panel restoration and refinish",
        image: "/assets/work/work-restoration-prep.webp",
        alt: "Real Revautoz work — masked panel being refinished during restoration",
        aspect: "aspect-[4/5]",
        placeholder: false,
    },
];
